import { createReducer } from 'Helpers/redux'
import {
  GET_TIKTOK_TRACK,
  GET_TIKTOK_TRACK_WITHOUT_AUTH,
  SET_TIKTOK_TRACK,
} from 'Redux/actions/trackActions'
import { ADD_NEW_TIK_TOK_CAMPAIGN } from '../actions/campaignActions'
import { SET_TRACK_TO_INITIAL_STATE } from '../actions/trackActions'

const initialState = {
  tempTransitForTrack: null,
  tikTokTrack: null,
}

const handlers = {
  [GET_TIKTOK_TRACK.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    tempTransitForTrack: payload,
  }),
  [GET_TIKTOK_TRACK.FAILURE]: prevState => ({
    ...prevState,
    tikTokTrack: null,
  }),
  [GET_TIKTOK_TRACK_WITHOUT_AUTH.SUCCESS]: (prevState, { payload }) => ({
    ...prevState,
    tempTransitForTrack: payload,
  }),
  [GET_TIKTOK_TRACK_WITHOUT_AUTH.FAILURE]: prevState => ({
    ...prevState,
    tikTokTrack: null,
  }),
  [SET_TIKTOK_TRACK]: (prevState, { payload }) => ({
    ...prevState,
    tikTokTrack: payload ? prevState.tempTransitForTrack : null,
  }),
  [SET_TRACK_TO_INITIAL_STATE]: () => ({
    ...initialState,
  }),
  [ADD_NEW_TIK_TOK_CAMPAIGN.SUCCESS]: () => ({
    ...initialState,
  }),
}

export default createReducer(initialState, handlers)
